import {
  useBoolean,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Flex,
  Text,
  Box,
  Table,
  Thead,
  Tr,
  Tbody,
  Td,
  Th,
  Tfoot
} from '@chakra-ui/react'
import * as crypto from 'crypto-js'
import fileDownload from 'js-file-download'
import {
  createContext,
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react'
import { AiOutlineBarChart } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import LayoutLoader from '@component/Layout/Loader'
import SapHistoricModalWrapper from '@component/Layout/Tools/SapHistoricModalWrapper'
import MrpPeriodChart from '@component/Modules/Mrp/Modals/PeriodChart'

import { parseDistributionMrpData } from '@helper/grid'
import paramsHelper from '@helper/params'
import {
  decrypterHeaderStorange,
  encrypteHeaderStorange,
  mergeStoredHeaders
} from '@helper/util/cryptoStorange'
import generic from '@service/generic'
import mrp from '@service/mrp'

import {
  ITableGridAction,
  ITableHeader
} from '@base/@types/components/Layout/TableGrid'
import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import {
  IMrpDistributionContext,
  IParams,
  IUpdateParams,
  MrpDistributionCalc,
  IParamsSap,
  IUpdateParamsSap,
  Discount,
  bufferObj,
  bufferFooter
} from '@base/@types/providers/Mrp/DistributionProvider'
import mrpDistributionHeader from '@base/variables/headers/mrp/distribution'
const MrpDistributionProvider: FC = ({ children }) => {
  const toast = useToast()
  const [loading, setLoading] = useState(false)
  const [fetching, _setFetching] = useState(false)
  const [filters, setFilters] = useBoolean(true)

  const [query, setQuery] = useState('')
  const [filename, setFilename] = useState('MRP Distribuição')

  const [selected, setSelected] = useState<any>()
  const [sapFlag, setSapFlag] = useState<boolean | null>(null)
  const [vmmFlag, setVmmFlag] = useState<boolean | null>(null)
  const [lastSearchVmm, setLastSearchVmm] = useState(false)

  const [supplyMethod, updateSupplyMethod] = useImmer<any[]>([])
  const [discountSupply, updateDiscountSupply] = useImmer<Discount>({
    id: 0,
    desconto: 0,
    fornecedorId: 0,
    metodoPagamentoId: 0
  })

  const [data, updateData] = useImmer<any[]>([])
  const dataRef = useRef<any[]>([])

  const [paramsSap, updateSapParams] = useImmer<IParamsSap>({
    desconto: '',
    metodoPagamento: []
  })

  const [calc, updateCalc] = useImmer<MrpDistributionCalc>({
    skusDistintos: 0,
    pesoTotal: 0,
    custoRecomendado: 0,
    custoTotalDaDistribuicao: 0
  })

  const [params, updateParams] = useImmer<IParams>({
    centrosDistribuicaoIds: [],
    categoriasCompactasIds: [],
    produtosIds: [],
    gerenteCategoriaIds: [],
    gerenteProdutoIds: [],
    mundoIds: [],
    lojasIds: [],
    curvaAbc: [],
    tiposAlertas: [],
    subCategoriaSelectIds: [],

    curvaIgualZeroRadio: '',
    quantidadeEstoqueRadio: '',
    formatadaZeroRadio: '',
    utilizarVendaMediaMovel: 'Média Móvel',
    gruposSeparacao: ''
  })

  const [possuirBuffer] = useImmer<any[]>([])

  const [buffers, updateBuffers] = useImmer<bufferObj[]>([])
  const [centroBuffer, updateCentroBuffer] = useImmer<bufferObj>({})
  const [bufferFooter, updateBufferFooter] = useImmer<bufferFooter>({
    disponivel: 0,
    reservado: 0
  })

  const [currentOrderCode, setCurrentOrderCode] = useState('')
  // Trava contra envio duplicado do pedido ao SAP
  const isSubmittingRef = useRef(false)
  const [sendingOrder, setSendingOrder] = useState(false)

  const handleClearOrderCode = () => {
    setCurrentOrderCode('')
  }
  const [loadingBufferModal, setLoadingBufferModal] = useState(false)
  const filtersList = useMemo<any[]>(() => {
    return [
      ...(vmmFlag
        ? [
            {
              id: 'utilizarVendaMediaMovel',
              label: 'Projeção',
              type: 'radio',
              values: ['Lambda', 'Média Móvel']
            }
          ]
        : []),
      {
        id: 'lojasIds',
        label: 'Centro',
        filterId: 'centers',
        type: 'select',
        isMulti: true
      },
      {
        id: 'centrosDistribuicaoIds',
        label: 'Centro de Distribuição',
        filterId: 'distributionCenters',

        type: 'select',
        isMulti: true
      },
      // {
      //   id: 'gerenteCategoriaIds',
      //   label: 'Gerente de Categoria',
      //   filterId: 'categoryManagers',
      //   type: 'select',
      //   isMulti: true,
      //   isDisabled: params.produtosIds?.length > 0
      // },
      {
        id: 'gerenteProdutoIds',
        label: 'Gerente de Produto',
        filterId: 'productManagers',
        type: 'select',
        isMulti: true,
        isDisabled: params.produtosIds?.length > 0
      },
      // {
      //   id: 'mundoIds',
      //   label: 'Mundo',
      //   filterId: 'worlds',

      //   type: 'select',
      //   isMulti: true
      // },
      {
        id: 'categoriasCompactasIds',
        label: 'Categoria Compacta',
        filterId: 'compactCategories',
        type: 'select',
        isMulti: true
      },
      {
        id: 'subCategoriaSelectIds',
        label: 'Sub Categoria',
        filterId: 'subCategories',

        type: 'select',
        isMulti: true
      },

      {
        id: 'produtosIds',
        label: 'Produto',
        type: 'select-api-post',
        apiUrl: '/v1/Produto/Distribuicoes',
        isMulti: true
      },
      {
        id: 'gruposSeparacao',
        label: 'Cronograma',
        filterId: 'gruposSeparacao',
        type: 'select-pagination',
        pagination: true,
        isMulti: true
      },
      {
        id: 'curvaAbc',
        label: 'Curva',
        filterId: 'abcCurves',
        isMulti: true,
        type: 'select',
        limit: 1
      },
      {
        id: 'tiposAlertas',
        label: 'Tipo de Alerta',
        filterId: 'typeOfAlert',
        isMulti: true,
        type: 'select'
      },

      {
        id: 'curvaIgualZeroRadio',
        label: 'Sugerida',
        type: 'radio',
        values: ['> 0', '= 0']
      },
      {
        id: 'quantidadeEstoqueRadio',
        label: 'Quantidade de Estoque',
        type: 'radio',
        values: [' > 0', ' = 0']
      },
      {
        id: 'formatadaZeroRadio',
        label: 'Formatada',
        type: 'radio',
        values: ['> 0', '= 0']
      }
    ]
  }, [params.produtosIds?.length, vmmFlag])
  const handleUpdateSapParams = useCallback(
    ({ name, value }: IUpdateParamsSap) => {
      updateSapParams(draft => {
        draft[name] = value
      })
    },
    [updateSapParams]
  )

  const isSapExportFlag = async () => {
    try {
      const { data: res } = await generic.getConfig(
        'FLAG_EXPORTAR_SAP_DISTRIBUICAO'
      )
      const { data } = res
      if (data?.valor === 'true') {
        return true
      } else {
        return false
      }
    } catch {
      return false
    }
  }

  const isVmmFlag = async () => {
    try {
      const { data: res } = await generic.getConfig('FLAG_VENDAMEDIAMOVEL')
      const { data } = res
      return data?.valor === 'true'
    } catch {
      return false
    }
  }

  const getSupplyCommands = useCallback(async () => {
    try {
      const { data: res } = await generic.getSupplyMethods()

      const { data } = res

      updateSupplyMethod(data)
    } catch {}
    setLoading(false)
  }, [updateSupplyMethod])
  // A configuração salva entra já na inicialização do estado. Restaurá-la
  // depois, em efeito ou durante a busca, descartava a seleção que o usuário
  // tinha acabado de aplicar.
  const [headers, updateHeaders] = useImmer<ITableHeader[]>(() =>
    mergeStoredHeaders(
      mrpDistributionHeader,
      decrypterHeaderStorange('mrpDistributionMrp')
    )
  )

  // Espelhado durante o render (e não em um efeito): as actions `columns` e
  // `export` leem este ref por getter, e um efeito as deixaria um render
  // atrasadas — mostrando e exportando a seleção de colunas anterior.
  const headersRef = useRef(headers)
  headersRef.current = headers

  const getDiscountBySupply = useCallback(async () => {
    const distribution = data

    try {
      const { data: res } = await generic.getDiscountSupply({
        fornecedoresIds: [
          distribution[0].estoque.idEmpresa > 0
            ? distribution[0].estoque.idEmpresa
            : 0
        ]
      })

      const { data } = res

      updateDiscountSupply(data[0])
      const newParamsSap = paramsSap
      updateSapParams({ ...newParamsSap, desconto: data[0].desconto })
    } catch {}
  }, [data, updateDiscountSupply, paramsSap, updateSapParams])

  const exportData = useCallback(async () => {
    Swal.fire({
      title: 'Exporta dados!',
      html: 'Aguarde um momento<b></b>.',
      timerProgressBar: true,
      timer: 99999,
      didOpen: () => {
        Swal.showLoading()
      }
    })
    const purshase = data
    const command = {
      lojaConfiguracaoGrid: {
        codigo: headers[0].columns[0] ? headers[0].columns[0].show : true,
        nome: headers[0].columns[0] ? headers[0].columns[1].show : true
      },
      centroDistribuicaoConfiguracaoGrid: {
        codigo: true,
        nome: true
      },
      produtoConfiguracaoGrid: {
        material: true,
        leadTime: true,
        intervaloCompra: true,
        codigo: headers[2].columns[0] ? headers[2].columns[0].show : true,
        nome: headers[2].columns[1] ? headers[2].columns[1].show : true,
        categoria: headers[2].columns[4] ? headers[2].columns[4].show : true,
        curvaABC: headers[2].columns[5] ? headers[2].columns[5].show : true,
        curvaABCEmpresa: headers[2].columns[6]
          ? headers[2].columns[6].show
          : true,
        status: headers[2].columns[7] ? headers[2].columns[7].show : true,
        loteMultiplo: headers[2].columns[8] ? headers[2].columns[8].show : true,
        grupoSeparacao: headers[2].columns[9]
          ? headers[2].columns[9].show
          : true,
        MundoCodigo: headers[2].columns[2] ? headers[2].columns[2].show : true,
        MundoDescricao: headers[2].columns[2]
          ? headers[2].columns[2].show
          : true,
        CategoriaCompactaDescricao: headers[2].columns[3]
          ? headers[2].columns[3].show
          : true,
        CategoriaCompactaCodigo: headers[2].columns[3]
          ? headers[2].columns[3].show
          : true
      },
      fornecedorConfiguracaoGrid: {
        codigo: headers[3].columns[0] ? headers[3].columns[0].show : true,
        nome: headers[3].columns[1] ? headers[3].columns[1].show : true
      },

      recomendacaoConfiguracaoGrid: {
        pedidos: true,
        coberturaMedia: true,
        quantidade: headers[4].columns[0] ? headers[4].columns[0].show : true,
        peso: headers[4].columns[1] ? headers[4].columns[1].show : true,
        custo: headers[4].columns[3] ? headers[4].columns[3].show : true,
        volume: headers[4].columns[2] ? headers[4].columns[2].show : true,
        tipoAlerta: headers[4].columns[4] ? headers[4].columns[4].show : true,
        nivelServico: headers[4].columns[5] ? headers[4].columns[5].show : true
      },
      compraConfiguracaoGrid: {
        pedidos: true,
        quantidade: true,
        coberturaMedia: true,
        peso: headers[5].columns[0] ? headers[5].columns[0].show : true,
        volume: headers[5].columns[1] ? headers[5].columns[1].show : true,
        desejada: headers[5].columns[2] ? headers[5].columns[2].show : true,
        custo: headers[5].columns[3] ? headers[5].columns[3].show : true,
        nivelServico: headers[5].columns[4] ? headers[5].columns[4].show : true
      },

      estoqueConfiguracaoGrid: {
        max: headers[6].columns[0] ? headers[6].columns[0].show : true,
        cd: headers[6].columns[1] ? headers[6].columns[1].show : true,
        reservado: headers[6].columns[2] ? headers[6].columns[2].show : true,

        disponivel: headers[6].columns[3] ? headers[6].columns[3].show : true,
        transito: headers[6].columns[4] ? headers[6].columns[4].show : true,
        dep16: headers[6].columns[5] ? headers[6].columns[5].show : true,
        outros: headers[6].columns[6] ? headers[6].columns[6].show : true,
        vendaMediaDiaria: headers[6].columns[7]
          ? headers[6].columns[7].show
          : true,
        vendaMediaMensal: headers[6].columns[8]
          ? headers[6].columns[8].show
          : true
      },

      estoqueReabEmergencialConfiguracaoGrid: {
        estoqueAtual: true,
        pedidosEmTransito: true,
        coberturaAtual: true,
        curvaABC: true,
        estoqueCD: true,
        quantidadeSugerida: true,
        peso: true
      },

      coberturaConfiguracaoGrid: {
        alvo: headers[7].columns[0] ? headers[7].columns[0].show : true,
        atual: headers[7].columns[1] ? headers[7].columns[1].show : true,
        transito: headers[7].columns[2] ? headers[7].columns[2].show : true,
        sugestao: headers[7].columns[3] ? headers[7].columns[3].show : true,
        desejada: headers[7].columns[4] ? headers[7].columns[4].show : true,
        diferenca: headers[7].columns[5] ? headers[7].columns[5].show : true
      }
    }
    try {
      const { data: res } = await mrp.postDistributionExport({
        params: {
          recomendacaoFornecimentoCommand: purshase,
          configuracaoGridCommand: command
        }
      })
      Swal.close()
      fileDownload(res, filename + '.csv')
    } catch (error: any) {
      const { data } = error.response
      Swal.close()

      const message =
        data.response?.status === 400
          ? data.response?.data?.data[0].message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'error',
        duration: 2000,
        isClosable: true
      })
    }
  }, [data, toast, filename, headers])

  const exportDataSap = useCallback(async () => {
    // Trava contra envio duplicado (duplo clique)
    if (isSubmittingRef.current) return
    const linhasValidas = data.filter(item => item.desejada?.quantidade > 0)

    // 2. Valide verificando se o array filtrado tem algum item.
    if (linhasValidas.length === 0) {
      toast({
        title: 'Atenção.',
        description:
          'Nenhuma (Compra Desejada) maior que zero encontrada para exportação',
        status: 'warning',
        duration: 4000,
        isClosable: true
      })
      return
    }

    isSubmittingRef.current = true
    setSendingOrder(true)

    Swal.fire({
      title: 'Criando Pedidos!',
      html: 'Aguarde um momento<b></b>.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      backdrop: true,
      didOpen: () => {
        Swal.showLoading()
      }
    })

    // 3. Use o array JÁ FILTRADO para a variável 'purshase'.
    const purshase = linhasValidas
    let obj = {}
    const unique = [...new Set(data.map(item => item.estoque.idEmpresa))]
    if (unique.length !== 1) {
      obj = {
        recomendacaoFornecimentoCommand: purshase,
        desconto:
          Number(paramsSap.desconto) !== 0 ? Number(paramsSap.desconto) : null,
        formaDePagamento: paramsSap.metodoPagamento[0]
          ? paramsSap.metodoPagamento[0].value !== 0
            ? paramsSap.metodoPagamento[0].value
            : null
          : null
      }
    } else {
      obj = {
        recomendacaoFornecimentoCommand: purshase,
        desconto:
          Number(paramsSap.desconto) !== 0 ? Number(paramsSap.desconto) : null,
        formaDePagamento: paramsSap.metodoPagamento[0]
          ? paramsSap.metodoPagamento[0].value !== 0
            ? paramsSap.metodoPagamento[0].value
            : null
          : null
      }
    }
    try {
      const { data: res, status } = await mrp.postDistributionExportSap({
        params: obj
      })
      // Verificação manual do status de resposta e conteúdo
      if (status !== 200 || res?.erro || res?.error || res?.statusCode >= 400) {
        throw new Error(res?.message || 'Erro ao processar pedido')
      }

      setCurrentOrderCode('105')
      toast({
        title: 'Sucesso.',
        description: 'Pedido criado com Sucesso',
        status: 'success',
        duration: 2000,
        isClosable: true
      })
      Swal.close()
    } catch (error: any) {
      Swal.close()
      const message =
        error.response?.status === 400
          ? error.response?.data?.message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: error.response?.status === 400 ? 'warning' : 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      isSubmittingRef.current = false
      setSendingOrder(false)
    }
  }, [data, toast, paramsSap])

  const exportDataSapFormatada = useCallback(async () => {
    // Trava contra envio duplicado (duplo clique)
    if (isSubmittingRef.current) return
    const linhasValidas = data.filter(
      item => item.resultadoFormacaoCarga?.quantidadeEnviada > 0
    )

    // 2. Valide usando o tamanho (length) do array recém-criado.
    if (linhasValidas.length === 0) {
      toast({
        title: 'Atenção.',
        description:
          'Nenhuma (Quantidade Formatada) maior que zero encontrada para exportação',
        status: 'warning',
        duration: 4000,
        isClosable: true
      })
      return
    }

    isSubmittingRef.current = true
    setSendingOrder(true)

    Swal.fire({
      title: 'Criando Pedidos!',
      html: 'Aguarde um momento<b></b>.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      backdrop: true,
      didOpen: () => {
        Swal.showLoading()
      }
    })

    // 3. Atribua o array JÁ FILTRADO à variável 'purshase'.
    const purshase = linhasValidas

    let obj = {}
    const unique = [...new Set(data.map(item => item.estoque.idEmpresa))]
    if (unique.length !== 1) {
      obj = {
        recomendacaoFornecimentoCommand: purshase,
        desconto:
          Number(paramsSap.desconto) !== 0 ? Number(paramsSap.desconto) : null,
        formaDePagamento: paramsSap.metodoPagamento[0]
          ? paramsSap.metodoPagamento[0].value !== 0
            ? paramsSap.metodoPagamento[0].value
            : null
          : null
      }
    } else {
      obj = {
        recomendacaoFornecimentoCommand: purshase,
        desconto:
          Number(paramsSap.desconto) !== 0 ? Number(paramsSap.desconto) : null,
        formaDePagamento: paramsSap.metodoPagamento[0]
          ? paramsSap.metodoPagamento[0].value !== 0
            ? paramsSap.metodoPagamento[0].value
            : null
          : null
      }
    }
    try {
      const { data: res, status } =
        await mrp.postDistributionExportSapFormatada({
          params: obj
        })

      // Verificação manual do status de resposta e conteúdo
      if (status !== 200 || res?.erro || res?.error || res?.statusCode >= 400) {
        throw new Error(res?.message || 'Erro ao processar pedido')
      }
      setCurrentOrderCode('105')
      toast({
        title: 'Sucesso.',
        description: 'Pedido criado com Sucesso',
        status: 'success',
        duration: 2000,
        isClosable: true
      })
      Swal.close()
    } catch (error: any) {
      Swal.close()
      const message =
        error.response?.status === 400
          ? error.response?.data?.message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: error.response?.status === 400 ? 'warning' : 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      isSubmittingRef.current = false
      setSendingOrder(false)
    }
  }, [data, toast, paramsSap])

  const exportDataSapCsv = useCallback(async () => {
    Swal.fire({
      title: 'Exporta dados!',
      html: 'Aguarde um momento<b></b>.',
      timerProgressBar: true,
      timer: 99999,
      didOpen: () => {
        Swal.showLoading()
      }
    })
    const purshase = data

    let obj = {}
    const unique = [...new Set(data.map(item => item.estoque.idEmpresa))]
    if (unique.length !== 1) {
      obj = {
        recomendacaoFornecimentoCommand: purshase,
        desconto:
          Number(paramsSap.desconto) !== 0 ? Number(paramsSap.desconto) : null,
        formaDePagamento: paramsSap.metodoPagamento[0]
          ? paramsSap.metodoPagamento[0].value !== 0
            ? paramsSap.metodoPagamento[0].value
            : null
          : null
      }
    } else {
      obj = {
        recomendacaoFornecimentoCommand: purshase,
        desconto:
          Number(paramsSap.desconto) !== 0 ? Number(paramsSap.desconto) : null,
        formaDePagamento: paramsSap.metodoPagamento[0]
          ? paramsSap.metodoPagamento[0].value !== 0
            ? paramsSap.metodoPagamento[0].value
            : null
          : null
      }
    }
    try {
      const { data: res } = await mrp.postDistributionExportSapCsv({
        params: obj
      })
      fileDownload(res, filename + '.csv')
      Swal.close()
    } catch (error: any) {
      Swal.close()
      const message =
        error.response?.status === 400
          ? error.response?.data?.message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: error.response?.status === 400 ? 'warning' : 'error',
        duration: 2000,
        isClosable: true
      })
    }
  }, [data, toast, filename, paramsSap])

  const exportDataSapFormatadaCsv = useCallback(async () => {
    Swal.fire({
      title: 'Exporta dados!',
      html: 'Aguarde um momento<b></b>.',
      timerProgressBar: true,
      timer: 99999,
      didOpen: () => {
        Swal.showLoading()
      }
    })
    const purshase = data

    let obj = {}
    const unique = [...new Set(data.map(item => item.estoque.idEmpresa))]
    if (unique.length !== 1) {
      obj = {
        recomendacaoFornecimentoCommand: purshase,
        desconto:
          Number(paramsSap.desconto) !== 0 ? Number(paramsSap.desconto) : null,
        formaDePagamento: paramsSap.metodoPagamento[0]
          ? paramsSap.metodoPagamento[0].value !== 0
            ? paramsSap.metodoPagamento[0].value
            : null
          : null
      }
    } else {
      obj = {
        recomendacaoFornecimentoCommand: purshase,
        desconto:
          Number(paramsSap.desconto) !== 0 ? Number(paramsSap.desconto) : null,
        formaDePagamento: paramsSap.metodoPagamento[0]
          ? paramsSap.metodoPagamento[0].value !== 0
            ? paramsSap.metodoPagamento[0].value
            : null
          : null
      }
    }
    try {
      const { data: res } = await mrp.postDistributionExportSapFormatadaCsv({
        params: obj
      })
      fileDownload(res, filename + '.csv')
      Swal.close()
    } catch (error: any) {
      Swal.close()
      const message =
        error.response?.status === 400
          ? error.response?.data?.message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: error.response?.status === 400 ? 'warning' : 'error',
        duration: 2000,
        isClosable: true
      })
    }
  }, [data, toast, filename, paramsSap])
  const handleUpdateWanted = useCallback(
    async (index: number, wanted: number | string) => {
      const purchase = data.filter(x => x.estoque.id === Number(index))
      const ind = data.findIndex(x => x.estoque.id === Number(index))

      let purchases = [...data]
      if (purchase[0]?.desejada) {
        // verifica se a propriedade existe
        purchase[0] = {
          ...purchase[0],
          desejada: {
            ...purchase[0].desejada,
            quantidade: '' // atribui o valor para a propriedade
          }
        }
      }
      purchases = [...purchases] // important to create a copy, otherwise you'll modify state outside of setState call
      purchases[ind] = purchase[0]
      const newData = purchases
      updateData(draft => {
        return draft.filter(item => item.status === 99).concat(newData)
      })

      try {
        const {
          data: { data }
        } = await mrp.putPurshaseWanted({
          page: 1,
          params: {
            quantidadeDesejada: wanted.toString().replace(/\.|\-/g, ''),
            recomendacaoFornecimentoCommand: purchase[0]
          }
        })

        const idData = purchases.findIndex(
          (x: any) => x.estoque.id === Number(index)
        )

        purchases = [...purchases] // important to create a copy, otherwise you'll modify state outside of setState call
        purchases[idData] = data

        const newData = purchases

        updateData(draft => {
          return draft.filter(item => item.status === 99).concat(newData)
        })
        calculate(purchases)
      } catch (error: any) {
        const message =
          error.response?.status === 400
            ? error.response?.data?.message
            : 'Ocorreu um problema interno. Tente novamente mais tarde'
        toast({
          title: 'Atenção.',
          description: message,
          status: 'warning',
          duration: 2000,
          isClosable: true
        })
      }
      // setLoading(false)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, updateData]
  )

  const saveHeadersTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null
  )

  const handleHeaderLocalStorange = useCallback((header: any) => {
    if (saveHeadersTimeoutRef.current) {
      clearTimeout(saveHeadersTimeoutRef.current)
    }
    saveHeadersTimeoutRef.current = setTimeout(() => {
      localStorage.removeItem('mrpDistributionMrp')
      encrypteHeaderStorange('mrpDistributionMrp', header)
    }, 300)
  }, [])

  const toggleColumn = useCallback(
    (index: number, column: number) => {
      updateHeaders(draft => {
        const col = draft[index]?.columns[column]
        if (col) {
          col.show = !col.show
          // Marks the column as configured by the user. It must not flip with
          // `show`, otherwise the column editor loses track of the group.
          col.notShowColumn = true
        }
      })
    },
    [updateHeaders]
  )

  const actions = useMemo<ILayoutToolsAction[]>(() => {
    if (sapFlag === null) return []

    return [
      {
        type: 'purchaseSuppliers-createOrder-distribuition',
        data: data,
        onUpdate: null
      },
      {
        type: 'export',
        exports: [
          {
            type: 'excel',
            entity: 'DistributionMrp',
            data,
            get headers() {
              return headersRef.current
            }
          },
          ...(sapFlag
            ? [
                {
                  type: 'sap' as const,
                  data,
                  entity: 'DistributionMrp',
                  sapModal: true
                },
                {
                  type: 'sap' as const,
                  data,
                  entity: 'DistributionMrpFormatada',
                  sapModal: true
                }
              ]
            : [])
        ]
      },
      {
        type: 'distributionUpload'
      },
      {
        type: 'columns',
        get data() {
          return headersRef.current
        },
        onToggleColumn: toggleColumn
      }
    ]
  }, [toggleColumn, data, sapFlag])

  const tableInteraction = useMemo<ITableGridAction[]>(() => {
    return [
      {
        type: 'icon',
        icon: <AiOutlineBarChart />,
        onSelect: setSelected
      },
      {
        type: 'iconCalculo'
      },
      {
        type: 'iconBuffer',
        icon: <AiOutlineBarChart />
      }
    ]
  }, [])

  const clearAllFilters = useCallback(() => {
    updateParams({
      ...params,
      centrosDistribuicaoIds: [],
      categoriasCompactasIds: [],
      produtosIds: [],
      gerenteCategoriaIds: [],
      gerenteProdutoIds: [],
      mundoIds: [],
      lojasIds: [],
      curvaAbc: [],
      tiposAlertas: [],
      curvaIgualZeroRadio: '',
      quantidadeEstoqueRadio: '',
      formatadaZeroRadio: '',
      utilizarVendaMediaMovel: 'Média Móvel',
      gruposSeparacao: ''
    })
    if (localStorage.getItem('mrpDistributionParams')) {
      localStorage.setItem(
        'mrpDistributionParams',
        crypto.AES.encrypt(
          JSON.stringify({
            ...params,
            centrosDistribuicaoIds: [],
            categoriasCompactasIds: [],
            produtosIds: [],
            gerenteCategoriaIds: [],
            gerenteProdutoIds: [],
            mundoIds: [],
            lojasIds: [],
            curvaAbc: [],
            tiposAlertas: [],
            curvaIgualZeroRadio: '',
            formatadaZeroRadio: '',
            gruposSeparacao: ''
          }),
          'CHAVE'
        ).toString()
      )
    }
  }, [params, updateParams])

  const handleUpdateParams = useCallback(
    ({ name, value }: IUpdateParams) => {
      updateParams(draft => {
        draft[name] = value
      })
      if (localStorage.getItem('mrpDistributionParams')) {
        const newParams: IParams[] = JSON.parse(
          crypto.AES.decrypt(
            localStorage.getItem('mrpDistributionParams'),
            'CHAVE'
          ).toString(crypto.enc.Utf8) || ''
        )

        localStorage.setItem(
          'mrpDistributionParams',
          crypto.AES.encrypt(
            JSON.stringify({ ...newParams, [name]: value }),
            'CHAVE'
          ).toString()
        )
      }
    },
    [updateParams]
  )

  const handleLocalParams = useCallback(async () => {
    if (localStorage.getItem('mrpDistributionParams')) {
      const newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('mrpDistributionParams'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
      newParams.utilizarVendaMediaMovel = 'Média Móvel'
      updateParams(newParams)
    } else {
      localStorage.setItem(
        'mrpDistributionParams',
        crypto.AES.encrypt(JSON.stringify(params), 'CHAVE').toString()
      )
    }
  }, [updateParams, params])

  const calculate = useCallback(
    (data: any) => {
      const distinctSkus: any[] = []

      let pesoTotal = 0
      let custoTotalDeCompra = 0
      let custoRecomendado = 0

      for (const row of data) {
        pesoTotal +=
          +row.estoque.produtoFornecedor.produto.peso.valor *
          +row.desejada.quantidade

        custoRecomendado +=
          +(row.valorRecomendacao.quantidade * row.estoque.custoUnitario) *
          row.estoque.produtoFornecedor.unidadeFornecedor.fatorConversao

        custoTotalDeCompra +=
          +(row.desejada.quantidade * row.estoque.custoUnitario) *
          row.estoque.produtoFornecedor.unidadeFornecedor.fatorConversao

        const checkOne = row.valorRecomendacao.quantidade > 0
        const checkTwo = !!distinctSkus.filter(x =>
          x.supplier ===
            (row.estoque.produtoFornecedor.fornecedor
              ? row.estoque.produtoFornecedor.fornecedor.id
              : 0) && x.product === row.estoque.produtoFornecedor.produto
            ? row.estoque.produtoFornecedor.produto.id
            : 0
        )

        if (checkOne && checkTwo) {
          distinctSkus.push({
            supplier: row.estoque.produtoFornecedor.fornecedor
              ? row.estoque.produtoFornecedor.fornecedor.id
              : 0,
            product: row.estoque.produtoFornecedor.produto
              ? row.estoque.produtoFornecedor.produto.id
              : 0
          })
        }
      }

      updateCalc(draft => {
        draft.skusDistintos = distinctSkus.length
        draft.pesoTotal = pesoTotal
        draft.custoRecomendado = custoRecomendado
        draft.custoTotalDaDistribuicao = custoTotalDeCompra
      })
    },
    [updateCalc]
  )

  const getData = useCallback(async () => {
    // await getMaintence()
    const isDisabledProgress =
      params.lojasIds.length > 0 ||
      params.categoriasCompactasIds.length > 0 ||
      params.produtosIds.length > 0 ||
      params.centrosDistribuicaoIds.length > 0 ||
      params.curvaAbc.length > 0 ||
      params.mundoIds.length > 0
    if (!isDisabledProgress) {
      toast({
        title: 'Atenção',
        description: 'Selecionar ao menos um filtro',
        status: 'warning',
        duration: 2000,
        isClosable: true
      })
      return
    }
    setLoading(true)

    try {
      const paramsToSend = {
        tiposAlertas: paramsHelper.parse(params.tiposAlertas),
        categoriasCompactasIds: paramsHelper.parse(
          params.categoriasCompactasIds
        ),
        produtosIds: paramsHelper.parse(params.produtosIds),
        gerenteProdutoIds: paramsHelper.parse(params.gerenteProdutoIds),
        gerenteCategoriaIds: paramsHelper.parse(params.gerenteCategoriaIds),
        centrosDistribuicaoIds: paramsHelper.parse(
          params.centrosDistribuicaoIds
        ),
        mundoIds: paramsHelper.parse(params.mundoIds),
        lojasIds: paramsHelper.parse(params.lojasIds),
        gruposSeparacao: params.gruposSeparacao
          ? paramsHelper.parseArray(params.gruposSeparacao)
          : [],
        curvaAbc: params.curvaAbc.length > 0 ? params.curvaAbc[0].value : '',
        quantidadeDesejadaSugerida: {
          maiorQueZero: params.curvaIgualZeroRadio === '> 0',
          igualZero: params.curvaIgualZeroRadio === '= 0'
        },
        quantidadeEstoque: {
          MaiorQueZero: params.quantidadeEstoqueRadio === ' > 0',
          IgualZero: params.quantidadeEstoqueRadio === ' = 0'
        },
        quantidadeDesejadaFormatada: {
          maiorQueZero: params.formatadaZeroRadio === '> 0',
          igualZero: params.formatadaZeroRadio === '= 0'
        },
        subCategoriasIds: paramsHelper.parse(params.subCategoriaSelectIds),
        utilizarVendaMediaMovel:
          !!vmmFlag && params.utilizarVendaMediaMovel === 'Média Móvel'
      }
      setLastSearchVmm(
        !!vmmFlag && params.utilizarVendaMediaMovel === 'Média Móvel'
      )
      const { data: res } = await mrp.getDistributionData({
        page: 1,
        params: paramsToSend
      })

      const { data, message } = res

      getDiscountBySupply()
      calculate(data)
      setFilters.toggle()

      updateData(draft => {
        return draft.filter(item => item.status === 99).concat(data)
      })
      if (message === 'ProdutosNaoParametrizados') {
        toast({
          title: 'Atenção.',
          description:
            'Alguns produtos não trouxeram resultado por não estarem parametrizados corretamente',
          status: 'error',
          duration: 6000,
          isClosable: true
        })
      }
    } catch (error: any) {
      setLoading(false)
      updateData([])
      updateCalc({
        skusDistintos: 0,
        pesoTotal: 0,
        custoRecomendado: 0,
        custoTotalDaDistribuicao: 0
      })
      // Verifica se error.response existe antes de acessar
      const response = error?.response
      const data = response?.data
      const status = response?.status

      setFilters.toggle()
      const message =
        status === 400
          ? data?.response?.data?.data?.[0]?.message || 'Erro de validação'
          : 'Ocorreu um problema interno. Tente novamente mais tarde'

      if (status !== 400) {
        toast({
          title: 'Atenção.',
          description: message,
          status: 'error',
          duration: 2000,
          isClosable: true
        })
      }
    }

    setLoading(false)
  }, [
    params.lojasIds,
    params.categoriasCompactasIds,
    params.produtosIds,
    params.centrosDistribuicaoIds,
    params.curvaAbc,
    params.mundoIds,
    params.tiposAlertas,
    params.gerenteProdutoIds,
    params.gerenteCategoriaIds,
    params.gruposSeparacao,
    params.curvaIgualZeroRadio,
    params.formatadaZeroRadio,
    params.quantidadeEstoqueRadio,
    params.subCategoriaSelectIds,
    params.utilizarVendaMediaMovel,
    vmmFlag,
    toast,
    getDiscountBySupply,
    calculate,
    setFilters,
    updateData,
    updateCalc
  ])

  const postUpload = useCallback(
    async (event: any) => {
      setLoading(true)

      const purshace = data
      try {
        const { data: res } = await mrp.uploadPurchase({
          file: event.target.files[0],
          params: purshace
        })

        const { data } = res

        updateData(draft => {
          return draft.filter(item => item.status === 99).concat(data)
        })
        calculate(data)
      } catch (error: any) {
        const { data } = error.response
        const message =
          data.response?.status === 400
            ? data.response?.data?.data[0].message
            : 'Ocorreu um problema interno. Tente novamente mais tarde'
        toast({
          title: 'Atenção.',
          description: message,
          status: 'error',
          duration: 2000,
          isClosable: true
        })
      }
      setLoading(false)
    },
    [toast, setLoading, data, updateData, calculate]
  )

  const [bufferModalOpen, setBufferModalOpen] = useState(false)
  const [bufferModalCentroId, setBufferModalCentroId] = useState<number>(0)
  const [bufferModalProdutoId, setBufferModalProdutoId] = useState<number>(0)

  const getBuffer = useCallback(
    async (storeId: number, productId: number) => {
      setBufferModalCentroId(storeId)
      setBufferModalProdutoId(productId)
      setBufferModalOpen(true)
      setLoadingBufferModal(true)
      generic
        .getBuffer(productId, storeId)
        .then(({ data: { data } }) => {
          updateBuffers(data.buffers)
          updateCentroBuffer(data.centro)

          updateBufferFooter({
            disponivel: data.totalDisponivel,
            reservado: data.totalReservado
          })
          setLoadingBufferModal(false)
        })
        .catch(() => {
          updateBuffers([])
          updateCentroBuffer({})
          updateBufferFooter({
            disponivel: 0,
            reservado: 0
          })
          setLoadingBufferModal(false)
        })
    },
    [updateBuffers, updateCentroBuffer, updateBufferFooter]
  )

  useEffect(() => {
    const fetchSapFlag = async () => {
      const flag = await isSapExportFlag()
      setSapFlag(flag)
    }
    const fetchVmmFlag = async () => {
      const flag = await isVmmFlag()
      setVmmFlag(flag)
    }
    fetchSapFlag()
    fetchVmmFlag()
  }, [])

  // Persiste a configuração sempre que ela muda. Na montagem regrava o mesmo
  // valor que acabou de ser restaurado, então é inofensivo.
  useEffect(() => {
    handleHeaderLocalStorange(headers)
  }, [headers, handleHeaderLocalStorange])

  useEffect(() => {
    dataRef.current = data
  }, [data])

  const parsedData = useMemo(() => parseDistributionMrpData(data), [data])

  const totalCount = data.length

  const contextValue = useMemo(
    () => ({
      loading,
      fetching,

      filtersList,
      tableInteraction,

      data: parsedData,
      dataAux: data,
      actions,
      params,
      calc,
      supplyMethod,
      discountSupply,

      headers,

      selected,
      filename,
      query,
      filters,

      toggleColumn,
      handleUpdateParams,
      paramsSap,
      handleUpdateWanted,
      handleUpdateSapParams,
      clearAllFilters,

      getData,

      exportData,
      exportDataSap,
      exportDataSapCsv,
      handleLocalParams,
      getSupplyCommands,
      getDiscountBySupply,
      postUpload,

      setSelected,
      setQuery,
      setFilters,
      setFilename,
      buffers,
      centroBuffer,
      getBuffer,
      possuirBuffer,
      bufferFooter,
      loadingBufferModal,
      exportDataSapFormatada,
      exportDataSapFormatadaCsv,
      lastSearchVmm,
      totalCount,
      sendingOrder
    }),
    [
      loading,
      fetching,
      filtersList,
      tableInteraction,
      parsedData,
      data,
      actions,
      params,
      calc,
      supplyMethod,
      discountSupply,
      headers,
      selected,
      filename,
      query,
      filters,
      toggleColumn,
      handleUpdateParams,
      paramsSap,
      handleUpdateWanted,
      handleUpdateSapParams,
      clearAllFilters,
      getData,
      exportData,
      exportDataSap,
      exportDataSapCsv,
      handleLocalParams,
      getSupplyCommands,
      getDiscountBySupply,
      postUpload,
      setSelected,
      setQuery,
      setFilters,
      setFilename,
      buffers,
      centroBuffer,
      getBuffer,
      possuirBuffer,
      bufferFooter,
      loadingBufferModal,
      exportDataSapFormatada,
      exportDataSapFormatadaCsv,
      lastSearchVmm,
      totalCount,
      sendingOrder
    ]
  )

  return (
    <MrpDistributionContext.Provider value={contextValue}>
      {children}
      {bufferModalOpen && (
        <Modal
          isCentered
          isOpen={bufferModalOpen}
          onClose={() => setBufferModalOpen(false)}
          scrollBehavior="inside"
          motionPreset="slideInBottom"
          colorScheme="white"
          size="6xl"
        >
          <ModalOverlay />
          <ModalContent
            background={'white'}
            marginLeft={[4, 8, 16]}
            marginRight={[4, 8, 16]}
          >
            <ModalHeader
              paddingTop={2}
              paddingBottom={2}
              paddingLeft={4}
              paddingRight={4}
              textColor={'gray.200'}
              background={'#1d5840'}
              borderTopLeftRadius={5}
              borderTopRightRadius={5}
              borderBottom="3px solid #ECC94B"
            >
              <Flex alignItems="center">
                <Text marginLeft={2}>Função Buffer</Text>
              </Flex>
            </ModalHeader>
            <ModalCloseButton
              top={1}
              right={1.5}
              textColor={'gray.200'}
              size="lg"
            />
            <ModalBody bg="white">
              {loadingBufferModal ? (
                <LayoutLoader
                  type="modal"
                  title="Recuperando informações..."
                  message="Aguarde enquanto buscamos os registros no banco de dados"
                />
              ) : buffers.length > 0 ? (
                <Box
                  p={4}
                  pt={6}
                  pb={6}
                  pos="relative"
                  maxW="100%"
                  overflow="auto"
                >
                  <Table size="sm" className="scl-table-grid">
                    <Thead>
                      <Tr>
                        <Th>Centro</Th>
                        <Th>Tipo centro</Th>
                        <Th>Produto Codigo</Th>
                        <Th>Produto Material</Th>
                        <Th>Disponivel</Th>
                        <Th>Reservado</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      <Tr>
                        <Td>{centroBuffer.centro}</Td>
                        <Td>CENTRO</Td>
                        <Td>{centroBuffer.produtoId}</Td>
                        <Td>{centroBuffer.produtoMaterial}</Td>
                        <Td>{centroBuffer.disponivel}</Td>
                        <Td>{centroBuffer.reservado}</Td>
                      </Tr>
                      {buffers.map((value, idx) => (
                        <Tr key={idx}>
                          <Td>{value.centro}</Td>
                          <Td>BUFFER</Td>
                          <Td>{value.produtoId}</Td>
                          <Td>{value.produtoMaterial}</Td>
                          <Td>{value.disponivel}</Td>
                          <Td>{value.reservado}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                    <Tfoot fontWeight={'black.500'}>
                      <Tr>
                        <Th fontSize={14} color={'black'}>
                          Total:
                        </Th>
                        <Th></Th>
                        <Th></Th>
                        <Th></Th>
                        <Th fontSize={14} color={'black'}>
                          {bufferFooter.disponivel.toLocaleString('pt-BR')}
                        </Th>
                        <Th fontSize={14} color={'black'}>
                          {bufferFooter.reservado.toLocaleString('pt-BR')}
                        </Th>
                      </Tr>
                    </Tfoot>
                  </Table>
                </Box>
              ) : (
                <Box>
                  <Flex
                    flexDir="column"
                    alignItems="center"
                    justifyContent="center"
                    bg="white"
                    borderRadius="8px"
                    h="calc(30vh - 128px)"
                    p={8}
                  >
                    <Text maxW="460px" fontSize={18} textAlign="center">
                      Não existe registro de buffers para o centro{' '}
                      {bufferModalCentroId} e o produto {bufferModalProdutoId}.
                    </Text>
                  </Flex>
                </Box>
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
      <SapHistoricModalWrapper
        orderCode={currentOrderCode}
        onModalClosed={handleClearOrderCode}
      />
      <MrpPeriodChart
        title="Distribuição"
        list={data}
        selected={selected}
        setSelected={setSelected}
      />
    </MrpDistributionContext.Provider>
  )
}

export default MrpDistributionProvider
export const MrpDistributionContext = createContext<IMrpDistributionContext>(
  {} as IMrpDistributionContext
)
